const ChatMediaGrid = ({ media, fileTypes, fileType, onMediaClick }) => {
  return (
    <div className="relative group">
      <div className="flex gap-2 overflow-x-auto scrollbar-hide rounded-lg p-2 shadow-sm bg-black/10">
        {media.map((url, index) => {
          const currentFileType =
            fileTypes && fileTypes[index] ? fileTypes[index] : fileType;

          if (currentFileType === "image") {
            return (
              <img
                key={index}
                src={url}
                alt="Shared"
                className="w-20 h-20 rounded-lg border border-white object-cover flex-shrink-0 cursor-pointer hover:opacity-90"
                onClick={() =>
                  onMediaClick({
                    previewUrl: url,
                    isImage: true,
                    isVideo: false
                  })
                }
              />
            );
          } else if (currentFileType === "video") {
            return (
              <video
                key={index}
                src={url}
                controls
                className="w-20 h-20 border border-white rounded-lg object-cover flex-shrink-0"
              />
            );
          }
        })}
      </div>
    </div>
  );
};

export default ChatMediaGrid;
